module.exports = __webpack_public_path__ + "static/media/moon_brown-min.0f8ca156.png";